import React, { useEffect, useState } from 'react';
import { Icon } from 'react-frontier';

interface QuantityProps{
	quantity: number,
	onChange: (q: number)=>void,
	format?: (v: number)=>string,
	style?: React.CSSProperties,
}

var Quantity = (props: QuantityProps)=>{
	var [inputValue, setInputValue] = useState<string>(String(props.quantity));

	useEffect(()=>{
		setInputValue(String(props.quantity));
	}, [props.quantity]);

	var handleInputChange = (e: React.ChangeEvent<HTMLInputElement>)=>{
		setInputValue(e.target.value);
	}

	var handleInputBlur = ()=>{
		var parsed = parseInt(inputValue);
		if(!isNaN(parsed) && parsed > 0){
			props.onChange(parsed);
		} else {
			setInputValue(String(props.quantity));
		}
	}

	var handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>)=>{
		if(e.key === 'Enter'){
			(e.target as HTMLInputElement).blur();
		}
	}

	return <div className="co quantity">
		<div className="left button" onClick={()=>props.onChange(Math.max(props.quantity-1, 1))}>
			<Icon name='minus' />
		</div>
		<div className="text">
			{props.format ? (
				props.format(props.quantity)
			) : (
				<input
					type="number"
					min={1}
					value={inputValue}
					onChange={handleInputChange}
					onBlur={handleInputBlur}
					onKeyDown={handleKeyDown}
					className="quantity-input"
				/>
			)}
		</div>
		<div className="right button" onClick={()=>props.onChange(props.quantity+1)}>
			<Icon name="plus" />
		</div>
	</div>
}

export default Quantity;